import {CartController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {LinkCheckoutGateway} from '@wc-stripe/gateways';

const settings = getSetting('stripe_link_checkout_data');

const context = new Context('cart');

const gateway = new LinkCheckoutGateway({
    id: 'stripe_link_checkout',
    settings,
    context
});

const controller = new CartController({
    context,
    gateway,
    selector: '#wc-stripe_link_checkout-cart-button'
});

controller.initialize();